import { render, staticRenderFns } from "./QCCollapse.vue?vue&type=template&id=6269668b"
import script from "./QCCollapse.vue?vue&type=script&lang=js"
export * from "./QCCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports